import type { ReviewEntryQuestion } from '../types/reviewEntryQuestion'
import { excludeThirdPartyQuestions } from './reviewEntryThirdPartyQuestion'

export const hasClarificationBadge = (questions: ReviewEntryQuestion[]): boolean =>
  excludeThirdPartyQuestions(questions).length > 0
